import React from 'react'
import './Navbar-b.css'

function NavbarB() {
    return (
        <div className="navbar-b-container">
            <nav className="navbar-b">
                <a href="/">
                    <ul className="navbar-b-logo-container">
                        <li className="logo-li-b">
                            <img src="/logo/logo-1.png" alt=""></img>
                        </li>
                        <li className="name-li-b">
                            <img src="/logo/logo-4.png" alt=""></img>
                        </li>
                    </ul>
                </a>
            </nav>
        </div>
    )
}

export default NavbarB
